export const isNotFoundError = (error: any) => error?.extensions?.statusCode === 404;
